// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2IqTk","exit":"Modal_exit__3YizC","form":"Modal_form__2YbKB","input":"Modal_input__2_jGR","types":"Modal_types__2jLim","noType":"Modal_noType___P6py"};